/** Matches school record header: "School Name (Institution Name)". */
export function formatSchoolAccountLabel(schoolName?: string | null, institutionName?: string | null): string {
  const school = schoolName?.trim() ?? '';
  const institution = institutionName?.trim() ?? '';
  if (!school) {
    return institution;
  }
  if (!institution) {
    return school;
  }
  return `${school} (${institution})`;
}
